import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from 'modules/CustomersAndRestaurants/Restaurants/RestaurantFullInfo/restaurantFullInfoState/restaurantFullInfoContext';
import React, { useContext } from 'react';

const BaseMccField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="baseMccLabel" value={restaurantForFullInfo?.merchantCategoryCode?.baseMcc} />;
};

export default BaseMccField;
